export enum EmptyStateSize {
  REGULAR = "regular",
  LARGE = "large"
}

export interface EmptyStateProps {
  iconUrl?: string;
  title: string;
  subtitle?: string;
  size?: EmptyStateSize;
  primaryButtonLabel?: string;
  secondaryButtonLabel?: string;
  primaryButtonOnClick?: () => void;
  secondaryButtonOnClick?: () => void;
}
